import { createContext } from "react";

const MainContext = createContext({
    showDialogUnexpectedError: false,
    setShowDialogUnexpectedError: null,
    reloadForUnexpectedError: null,
    setCloseDialogUnexpectedError: null,
    setDialogUnexpectedErrorMessage: null
});

export default MainContext;